import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Popover } from 'antd';

import { LicensesTablePriceMainStyled, PriceContainerStyled } from './LicensesTablePrice.styles';

interface LicensesTablePriceProps {
	price: number;
	canPurchaseApps: boolean;
	isFree: boolean;
}

export const LicensesTablePrice: FC<LicensesTablePriceProps> = ({ price, canPurchaseApps, isFree }) => {
	const { t } = useTranslation();

	return price && canPurchaseApps ? (
		<div>
			<LicensesTablePriceMainStyled>{`${price} ₽ / ${t(`Marketplace_Per_Month`)}`}</LicensesTablePriceMainStyled>
		</div>
	) : (
		<PriceContainerStyled>
			<LicensesTablePriceMainStyled>
				{isFree ? t(`Marketplace_Free`) : t(`Marketplace_Paid`)}
			</LicensesTablePriceMainStyled>
			<Popover content={t(`Marketplace_Price_Block_Popover`)} placement='bottom'>
				<QuestionCircleOutlined />
			</Popover>
		</PriceContainerStyled>
	);
};
